import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { TextAlignmentsEnum } from "../../../types/template-layouts";

import { OptionalComponent } from "../../../utils/optional-component";
import { MarkdownItem } from "../typography-item/typography-item";
import { replaceTextAlignAttribute } from "./replace-text-align-attribute";

interface IRenderEditorDescriptionProps {
	descriptionOverrides?: string;
	description: string;
	useNew?: boolean;
	defaultTextAlignment?: TextAlignmentsEnum;
}

const RenderEditorDescription: React.FC<IRenderEditorDescriptionProps> = ({
	description,
	descriptionOverrides,
	useNew = false,
	defaultTextAlignment = TextAlignmentsEnum.left
}) => {

	const [shouldUseNew, setShouldUseNew] = useState(true);

	useEffect(() => {
		if (useNew) {
			setShouldUseNew(true);
		} else {
			setShouldUseNew(false);
		}
	}, [useNew]);

	// if content is straight text (not html), we need to wrap it in html and give it the appropriate text alignment
	const convertToHtml = useCallback(() => {
		if (useNew) {
			return replaceTextAlignAttribute({ htmlString: description, newValue: defaultTextAlignment, bypassIfNodeElement: true });
		}
		return description;
	}, [description, useNew, defaultTextAlignment]);

	return (
		<>
			<OptionalComponent display={shouldUseNew}>
				<div className="quill-content">
					<div dangerouslySetInnerHTML={{ __html: convertToHtml() }} />
				</div>
			</OptionalComponent>

			<OptionalComponent display={!shouldUseNew}>
				<MarkdownItem className={classNames(descriptionOverrides)}>{description}</MarkdownItem>
			</OptionalComponent>
		</>
	);
};

export default RenderEditorDescription;
